import { observable } from 'mobx';


class Message {
  @observable content;
  @observable rawData;
  @observable variant;

  constructor(content, variant, rawData=null) {
    this.content = content;
    this.variant = variant;
    this.rawData = rawData;
  }
}


export default Message;
